"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EditPatient = void 0;
require("./edit-patient.less");
const asset_list_1 = require("client/components/asset-list");
const modal_1 = require("client/components/modal");
const callable_1 = require("client/components/ui/callable");
const react_1 = require("react");
const mobx_1 = require("mobx");
const confirmation_modal_1 = require("client/components/confirmation-modal");
const throttle_debounce_1 = require("throttle-debounce");
const ramda_1 = require("ramda");
const icons_1 = require("client/components/icons");
const ui_1 = require("client/components/ui");
const store_1 = require("client/modules/store");
const store_2 = require("client/modules/inventory/modules/inventory-list/store");
const multi_select_1 = require("client/components/ui/multi-select");
const store_3 = require("client/modules/users/store");
const store_4 = require("client/modules/app-settings/store");
const button_1 = require("client/components/material/button");
const checkbox_1 = require("client/components/material/checkbox/checkbox");
const date_picker_1 = require("client/components/material/date-picker/date-picker");
const icon_button_1 = require("client/components/material/icon-button");
const select_1 = require("client/components/material/select");
const table_1 = require("client/components/material/table");
const text_area_1 = require("client/components/material/text-area");
const text_field_1 = require("client/components/material/text-field");
const mobx_react_1 = require("mobx-react");
const store_5 = require("client/modules/orders/store");
const patient_image_1 = require("./components/patient-image");
const patient_merge_modal_1 = require("./components/patient-merge-modal");
const store_6 = require("../../../../store");
const router_1 = require("client/components/router");
const store_7 = require("client/modules/sites/modules/sites-list/store");
const alert_1 = require("client/components/ui/alert");
const upload_modal_1 = require("client/components/upload-modal");
const moment = require("moment");
const React = require("react");
const ReactTooltip = require("react-tooltip");
const DeleteForever_1 = require("material-ui-icons/DeleteForever");
const Edit_1 = require("material-ui-icons/Edit");
const dummyPatient = {
    address: "",
    address2: "",
    birthDate: "",
    city: "",
    confirmNoInsurance: false,
    email: "",
    firstName: "",
    gender: "",
    id: 0,
    insurances: [],
    lastName: "",
    middleName: "",
    missingInsurance: true,
    notes: "",
    phone: "",
    prefix: "",
    sites: [],
    state: "",
    suffix: "",
    uploads: [],
    zip: ""
};
const dummyInsurance = {
    benefitEffectiveDate: null,
    benefitIneffectiveDate: null,
    binNum: "",
    cardholderFirst: "",
    cardholderLast: "",
    copay: false,
    insuranceId: "",
    insuranceRelationship: 0,
    inventoryId: null,
    payerCoverageType: "",
    payerGroupId: "",
    payerIdCount: "",
    payerIdQualifier: "",
    payerPersonCode: "",
    payerPhone: "",
    pcn: "",
    primaryCopay: false,
    primaryInsurance: false
};
const statesStr = [
    "AK",
    "AL",
    "AR",
    "AZ",
    "CA",
    "CO",
    "CT",
    "DC",
    "DE",
    "FL",
    "GA",
    "HI",
    "ID",
    "IL",
    "IN",
    "IA",
    "KS",
    "KY",
    "LA",
    "ME",
    "MD",
    "MA",
    "MI",
    "MN",
    "MS",
    "MO",
    "MT",
    "NE",
    "NV",
    "NH",
    "NJ",
    "NM",
    "NY",
    "NC",
    "ND",
    "OH",
    "OK",
    "OR",
    "PA",
    "RI",
    "SC",
    "SD",
    "TN",
    "TX",
    "UT",
    "VT",
    "VA",
    "WA",
    "WV",
    "WI",
    "WY"
];
const states = statesStr.sort().map((state, i) => ({
    id: i,
    label: state,
    value: state
}));
const genderOptions = [
    {
        id: 1,
        label: "Male",
        value: "1"
    },
    {
        id: 2,
        label: "Female",
        value: "2"
    }
].sort((a, b) => (a.label > b.label ? 1 : -1));
// This should potentially be changed iterate through the existing
// list in InsuranceRelations (patients.ts).
const insuranceRelationshipOptions = [
    {
        id: 0,
        label: "Not Specified",
        value: "0"
    },
    {
        id: 1,
        label: "Cardholder",
        value: "1"
    },
    {
        id: 2,
        label: "Spouse",
        value: "2"
    },
    {
        id: 3,
        label: "Child",
        value: "3"
    },
    {
        id: 4,
        label: "Other",
        value: "4"
    }
];
let EditPatient = class EditPatient extends react_1.Component {
    constructor() {
        super(...arguments);
        this.inventoryFilterText = "";
        this.newExclude = {
            invId: "",
            reasonId: ""
        };
        this.editInsurance = false;
        this.requestButtonStyle = {
            backgroundColor: "rgb(0, 192, 121)",
            color: "white",
            marginRight: "1em"
        };
        /** Idle green matches New; loading uses project light blue (@link-shallow). */
        this.cardFinderIdleStyle = {
            backgroundColor: "#00c079",
            color: "#fff",
            marginRight: "1em",
            minWidth: "12.5em",
            whiteSpace: "nowrap"
        };
        this.cardFinderLoadingStyle = {
            backgroundColor: "#7da4ff",
            color: "#fff",
            marginRight: "1em",
            minWidth: "12.5em",
            whiteSpace: "nowrap",
            opacity: "1",
            cursor: "wait"
        };
        this.removeNDCConfirmationModal = false;
        this.confirmDeleteInsuranceModal = false;
        this.hideCardFinder = false;
        this.newPatientRequest = false;
        this.e1RequestInProgress = false;
        this.showConfirmationEditPatientSave = false;
        this.viewArchive = false;
        // image upload observables
        this.assetModal = false;
        this.photoUploadModal = false;
        this.showInsuranceFail = false;
        this.showMergeModal = false;
        this.siteSelectedId = "1";
        this.uploadModal = false;
        // @observable public isErrorStatus: boolean = false;
        // endregion
        // region Event handlers
        this.loadSites = throttle_debounce_1.debounce(200, async (filterText) => {
            const keyword = filterText || "";
            const options = {
                count: 100,
                group: "site.id",
                search: keyword,
                start: 0,
                where: ""
            };
            // sitesListStore.loadSites(options);
            await store_7.sitesListStore.loadSitesNoRelation(options);
        });
        this.handleSearch = (value) => availableInventoryOptions.filter((item) => item.label.toLowerCase().includes(value));
        this.handleUpdatePrimary = async (insurance) => {
            const isCopay = !!insurance.copay;
            const updated = Object.assign({}, insurance);
            isCopay
                ? (updated.primaryCopay = !updated.primaryCopay)
                : (updated.primaryInsurance = !updated.primaryInsurance);
            this.insurance = updated;
            await this.handleSubmit();
        };
        this.renderInsurance = () => {
            var _a, _b;
            const copayCards = [];
            const insuranceCards = [];
            (_b = (_a = this.patient) === null || _a === void 0 ? void 0 : _a.insurances) === null || _b === void 0 ? void 0 : _b.filter((insurance) => !insurance.deletedAt).forEach((insurance) => {
                !!insurance.copay
                    ? copayCards.push(insurance)
                    : insuranceCards.push(insurance);
            });
            const columns = ["ID", "Group", "BIN", "PCN", "Primary Card"].map((label) => ({
                id: `ins.${label
                    .toLowerCase()
                    .split(" ")
                    .join("")}`,
                label
            }));
            const renderRow = (row) => {
                const count = (row.copay ? copayCards : insuranceCards).length;
                const primary = Boolean(row.copay ? row.primaryCopay : row.primaryInsurance);
                return (React.createElement(table_1.MaterialTableRow, { key: row.insuranceId },
                    React.createElement(table_1.MaterialTableCell, { center: true },
                        React.createElement("div", { className: "ins__cell" }, row.insuranceId)),
                    React.createElement(table_1.MaterialTableCell, { center: true },
                        React.createElement("div", { className: "ins__cell" }, row.payerGroupId)),
                    React.createElement(table_1.MaterialTableCell, { center: true },
                        React.createElement("div", { className: "ins__cell" }, row.binNum)),
                    React.createElement(table_1.MaterialTableCell, { center: true },
                        React.createElement("div", { className: "ins__cell" }, row.pcn)),
                    React.createElement(table_1.MaterialTableCell, { center: true },
                        React.createElement("div", { className: "ins__cell--end" },
                            React.createElement(checkbox_1.MaterialCheckbox, { checked: primary, disabled: count === 1, label: null, onAction: async () => this.handleUpdatePrimary(row), value: "primaryCheck" }),
                            React.createElement(Edit_1.default, { onClick: () => this.openInsuranceEditModal(row) }),
                            React.createElement(DeleteForever_1.default, { onClick: () => {
                                    this.insurance = row;
                                    this.confirmDeleteInsuranceModal = true;
                                } })))));
            };
            return (React.createElement("div", { style: { display: "flex", flexDirection: "column" } }, [insuranceCards, copayCards].map((cards, i) => (React.createElement("div", { className: "row", style: { display: "flex", flexDirection: "column" } },
                React.createElement("p", { style: { alignSelf: "flex-start", fontWeight: 900 } },
                    i === 0 ? "Insurance" : "Copay",
                    " Cards"),
                React.createElement(table_1.MaterialTable, { rows: cards, columns: columns, order: "ASC", orderBy: "", renderRow: renderRow }))))));
        };
        this.newInsurance = () => {
            this.insurance = dummyInsurance;
            this.editInsurance = true;
        };
        this.filterPatientInventory = (inventoryId) => {
            this.patient.inventories = this.patient.inventories.filter(e => inventoryId !== e.inventoryId);
            this.ndcPendingRemoval = null;
        };
        this.editInsuranceModal = () => {
            var _a;
            const newInsurance = !((_a = this.insurance) === null || _a === void 0 ? void 0 : _a.id);
            const fields = () => {
                var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
                return (React.createElement("div", { className: "insurance-edit" },
                    React.createElement("div", { className: "row" },
                        React.createElement(text_field_1.MaterialTextField, { label: "Cardholder First Name", onChange: this.handleChangeInsurance("cardholderFirst"), value: (_a = this.insurance.cardholderFirst) !== null && _a !== void 0 ? _a : "" }),
                        React.createElement(text_field_1.MaterialTextField, { label: "Cardholder Last Name", onChange: this.handleChangeInsurance("cardholderLast"), value: (_b = this.insurance.cardholderLast) !== null && _b !== void 0 ? _b : "" })),
                    React.createElement("div", { className: "row" },
                        React.createElement(text_field_1.MaterialTextField, { label: "Insurance ID", onChange: this.handleChangeInsurance("insuranceId"), value: (_c = this.insurance.insuranceId) !== null && _c !== void 0 ? _c : "" }),
                        React.createElement(text_field_1.MaterialTextField, { label: "Group ID", onChange: this.handleChangeInsurance("payerGroupId"), value: (_d = this.insurance.payerGroupId) !== null && _d !== void 0 ? _d : "" })),
                    React.createElement("div", { className: "row" },
                        React.createElement(text_field_1.MaterialTextField, { label: "BIN", onChange: this.handleChangeInsurance("binNum"), value: (_e = this.insurance.binNum) !== null && _e !== void 0 ? _e : "" }),
                        React.createElement(text_field_1.MaterialTextField, { label: "PCN", onChange: this.handleChangeInsurance("pcn"), value: (_f = this.insurance.pcn) !== null && _f !== void 0 ? _f : "" })),
                    React.createElement("div", { className: "row row--insurance-edit" },
                        React.createElement(date_picker_1.MaterialDatePicker, { className: "modal-picker", label: "Effective Date", onChange: this.handleChangeEffective, value: (this.insurance.benefitEffectiveDate &&
                                this.insurance.benefitEffectiveDate.toString()) ||
                                "" }),
                        React.createElement(icon_button_1.MaterialIconButton, { onClick: this.handleClearInsuranceEffectiveDates("effective") },
                            React.createElement(icons_1.CloseIcon, null)),
                        React.createElement(date_picker_1.MaterialDatePicker, { className: "modal-picker", label: "Ineffective Date", onChange: this.handleChangeIneffective, value: (this.insurance.benefitIneffectiveDate &&
                                this.insurance.benefitIneffectiveDate.toString()) ||
                                "" }),
                        React.createElement(icon_button_1.MaterialIconButton, { onClick: this.handleClearInsuranceEffectiveDates("ineffective") },
                            React.createElement(icons_1.CloseIcon, null))),
                    React.createElement("h4", null, "Payer Data"),
                    React.createElement("div", { className: "row" },
                        React.createElement(text_field_1.MaterialTextField, { label: "Coverage Type", onChange: this.handleChangeInsurance("payerCoverageType"), value: (_g = this.insurance.payerCoverageType) !== null && _g !== void 0 ? _g : "" }),
                        React.createElement(text_field_1.MaterialTextField, { label: "ID Count", onChange: this.handleChangeInsurance("payerIdCount"), value: (_h = this.insurance.payerIdCount) !== null && _h !== void 0 ? _h : "" }),
                        React.createElement(text_field_1.MaterialTextField, { label: "ID Qualifier", onChange: this.handleChangeInsurance("payerIdQualifier"), value: (_j = this.insurance.payerIdQualifier) !== null && _j !== void 0 ? _j : "" }),
                        React.createElement(text_field_1.MaterialTextField, { label: "Person Code", onChange: this.handleChangeInsurance("payerPersonCode"), value: (_k = this.insurance.payerPersonCode) !== null && _k !== void 0 ? _k : "" })),
                    React.createElement("div", { className: "row" },
                        React.createElement(text_field_1.MaterialTextField, { label: "Payer Phone Number", onChange: this.handleChangeInsurance("payerPhone"), value: (_l = this.insurance.payerPhone) !== null && _l !== void 0 ? _l : "" }),
                        React.createElement(select_1.MaterialSelect, { label: "Insurance Relationship", 
                            // missing={this.missing.gender}
                            options: insuranceRelationshipOptions, onSelect: this.handleInsuranceRelationship("insuranceRelationship"), value: String(this.insurance.insuranceRelationship) }))));
            };
            const modalButtons = [
                React.createElement(button_1.MaterialButton, { onClick: () => {
                        this.insurance = null;
                        this.editInsurance = false;
                    } }, "Go Back"),
                React.createElement(button_1.MaterialButton, { onClick: async () => this.handleSubmit(), primary: true, style: { marginLeft: "1em" } }, "Confirm Insurance")
            ];
            const modal = (React.createElement(modal_1.Modal, { buttons: modalButtons, height: "60%", onCancel: () => {
                    this.editInsurance = false;
                }, top: "20%", width: "40%" },
                React.createElement("div", { className: "adasdasdasdasdsad", style: {
                        alignItems: "center",
                        display: "flex",
                        justifyContent: "space-around"
                    } },
                    React.createElement("b", { style: { fontSize: "1.5em" } },
                        newInsurance ? "New" : "Edit",
                        " Insurance"),
                    React.createElement(checkbox_1.MaterialCheckbox, { checked: this.insurance.copay, label: "This is a Copay Card", onAction: () => {
                            this.insurance.copay = !this.insurance.copay;
                        } })),
                this.insurance.copay ? (React.createElement(select_1.MaterialSelect, { className: "insurance-full-width", label: "Associated Medication", onSearch: e => (this.availableInventoryOptions = this.handleSearch(e)), onSelect: value => (this.insurance.inventoryId = value), options: [
                        {
                            id: 0,
                            label: "Use All Medications",
                            value: null
                        },
                        ...this.availableInventoryOptions
                    ], searchable: true, value: String(this.insurance.inventoryId) })) : (React.createElement(React.Fragment, null)),
                fields(),
                React.createElement("div", { style: {
                        display: "flex",
                        justifyContent: "space-around",
                        marginTop: "2em",
                        width: "100%"
                    } })));
            return modal;
        };
        this.checkConfirm = () => {
            const checked = this.patient.confirmNoInsurance;
            if (checked) {
                this.patient.confirmNoInsurance = false;
            }
            else {
                this.patient.confirmNoInsurance = true;
            }
        };
        this.renderArchive = (insurance, index) => (React.createElement("div", { className: "" },
            React.createElement("div", { className: "row" },
                React.createElement("div", { className: "type-info" },
                    React.createElement("div", { className: "type-info__column" },
                        React.createElement("div", { className: "value archive" },
                            index + 1,
                            ".")),
                    React.createElement("div", { className: "type-info__column" },
                        React.createElement("div", { className: "value archive" }, insurance.insuranceId)),
                    React.createElement("div", { className: "type-info__column" },
                        React.createElement("div", { className: "value archive" }, insurance.payerGroupId)),
                    React.createElement("div", { className: "type-info__column" },
                        React.createElement("div", { className: "value archive" }, insurance.binNum)),
                    React.createElement("div", { className: "type-info__column" },
                        React.createElement("div", { className: "value archive" }, insurance.pcn)),
                    React.createElement("div", { className: "type-info__column" },
                        React.createElement("div", { className: "value archive" }, insurance.benefitEffectiveDate &&
                            moment(new Date(insurance.benefitEffectiveDate)).format("MMMM , YYYY"))),
                    React.createElement("div", { className: "type-info__column" },
                        React.createElement("div", { className: "value archive" }, insurance.benefitIneffectiveDate &&
                            moment(new Date(insurance.benefitIneffectiveDate)).format("MMMM D, YYYY")))))));
        this.handleAssetsDescriptionsSave = async (uploads) => {
            await store_6.patientsStore.updateAssetsDescriptions(uploads);
            await store_6.patientsStore.readPatient(this.patient.id);
        };
        this.handleAssetsUpload = async (accepted) => {
            await store_6.patientsStore.upload(accepted, String(this.patient.id), this.uploadType);
            router_1.RouteManager.transitionTo(`/patients/${this.patient.id}`);
        };
        this.handleAssetsExpDateSave = async (uploads) => {
            await store_6.patientsStore.updateAssetsExpDate(uploads);
            await store_6.patientsStore.loadPatients();
        };
        this.checkIfNewPatient = () => {
            const splitPath = location.pathname.split("/");
            this.isNewPatient = (splitPath[splitPath.length - 1] === "0" || splitPath[splitPath.length - 2] === "0"); // E-075
        };
        this.hasSavedPatientId = (patient) => Boolean((patient === null || patient === void 0 ? void 0 : patient.id) && patient.id > 0);
        this.setMissingFields = () => {
            this.missing = {
                address: !this.patient.address,
                birthDate: !this.patient.birthDate,
                firstName: !this.patient.firstName,
                gender: !this.patient.gender,
                lastName: !this.patient.lastName,
                site: !this.patient.sites.length,
                zip: !this.patient.zip
            };
        };
        this.formatE1AuditAction = (message) => {
            if (!this.props.slim) {
                return message;
            }
            return message.replace(/\.$/, "") + " — schedule upload.";
        };
        this.isValid = (patient) => Boolean(patient.address &&
            patient.birthDate &&
            patient.firstName &&
            patient.gender &&
            patient.lastName &&
            patient.sites.length > 0 &&
            patient.zip);
        this.handleSelect = (fieldName) => (value) => {
            this.patient[fieldName] = value;
        };
        this.handleDeleteInsurance = async () => {
            const insuranceId = this.insurance.id;
            this.confirmDeleteInsuranceModal = false;
            const result = await store_6.patientsStore.insuranceDelete(insuranceId);
            const oldInsurance = this.insurance;
            oldInsurance.deletedAt = new Date();
            if (result) {
                this.editInsurance = false;
                this.patient.insurances = this.patient.insurances.filter((insurance) => insurance.id !== insuranceId);
                // This was added to have the deleted insurance appear in toggle history without refresh
                const sizeOf = this.patient.insurances.length;
                this.patient.insurances[sizeOf] = oldInsurance;
            }
            this.insurance = null;
        };
        this.handleInsuranceRelationship = (fieldName) => (value) => {
            this.insurance.insuranceRelationship = parseInt(value, 10);
        };
        this.isChanged = () => {
            var _a, _b, _c, _d, _e, _f;
            let resultP;
            let resultI;
            if (this.patient) {
                const originalPatient = ramda_1.merge(dummyPatient, this.props.patient);
                resultP = ramda_1.difference(Object.entries(this.patient), Object.entries(originalPatient));
            }
            if (this.insurance) {
                resultI = ramda_1.difference(Object.entries(this.insurance), Object.entries(this.originalInsurance || dummyInsurance));
            }
            if (((_a = this.props.patient) === null || _a === void 0 ? void 0 : _a.sites) && ((_b = this.patient) === null || _b === void 0 ? void 0 : _b.sites)) {
                const sitesComparison = ramda_1.difference(this.patient.sites.map(site => site.id), this.props.patient.sites.map(site => site.id));
                const sitesComparison2 = ramda_1.difference(this.props.patient.sites.map(site => site.id), this.patient.sites.map(site => site.id));
                if (sitesComparison.length > 0 || sitesComparison2.length > 0) {
                    return true;
                }
            }
            if (((_d = (_c = this.props.patient) === null || _c === void 0 ? void 0 : _c.inventories) === null || _d === void 0 ? void 0 : _d.length) || ((_f = (_e = this.patient) === null || _e === void 0 ? void 0 : _e.inventories) === null || _f === void 0 ? void 0 : _f.length)) {
                const propInv = this.patient.inventories;
                const patInv = this.props.patient.inventories;
                const sitesComparison = ramda_1.difference(patInv.map((pExcl) => pExcl.inventoryId), propInv.map((pExcl) => pExcl.inventoryId));
                const sitesComparison2 = ramda_1.difference(propInv.map((pExcl) => pExcl.inventoryId), patInv.map((pExcl) => pExcl.inventoryId));
                return sitesComparison.length > 0 || sitesComparison2.length > 0;
            }
            const didChange = (resultP && resultP.length > 0) || (resultI && resultI.length > 0);
            if (this.params.has("showcf"))
                this.hideCardFinder = !didChange;
            return didChange;
        };
        this.handleChangeString = (fieldName) => (event, value) => {
            if (fieldName === "zip") {
                const foundState = store_1.generalStore.getState(value);
                if (foundState !== "none") {
                    this.patient.state = foundState;
                }
            }
            this.patient[fieldName] = value;
        };
        this.handleChangeInsurance = (fieldName) => (event, value) => {
            this.insurance[fieldName] = value;
        };
        this.handleChangeNotes = (event) => {
            this.patient.notes = event.target.value;
        };
        this.handleChangeBirthdate = (value) => {
            this.patient.birthDate = moment(new Date(value)).format("YYYY-MM-DD");
        };
        this.handleClearInsuranceEffectiveDates = (field) => () => {
            if (field === "effective") {
                this.insurance.benefitEffectiveDate = null;
            }
            else if (field === "ineffective") {
                this.insurance.benefitIneffectiveDate = null;
            }
        };
        this.handleChangeEffective = (value) => {
            this.insurance.benefitEffectiveDate = moment(new Date(value)).format("YYYY-MM-DD");
        };
        this.handleChangeIneffective = (value) => {
            this.insurance.benefitIneffectiveDate = moment(new Date(value)).format("YYYY-MM-DD");
        };
        this.getMultiSelectValues = () => {
            const selectedItems = [];
            this.patient.sites &&
                this.patient.sites.map((site, i) => {
                    const item = {
                        id: site.id,
                        label: site.displayName || site.name,
                        tokenLabel: site.displayName || site.name,
                        value: String(site.id)
                    };
                    selectedItems.push(item);
                });
            return selectedItems;
        };
        this.getMultiSelectValuesInventories = () => {
            var _a;
            const selectedInventoryItems = [];
            (_a = this.patient.inventories) === null || _a === void 0 ? void 0 : _a.forEach((exclusion) => {
                if (!store_2.inventoryListStore.inventories.value.length)
                    return;
                const inventory = store_2.inventoryListStore.inventories.value.find(val => val.id === exclusion.inventoryId);
                const item = {
                    id: inventory.id,
                    label: inventory.package
                        ? `${inventory.package} (${inventory.name})`
                        : `${inventory.ndc} (${inventory.name})`,
                    tokenLabel: inventory.package
                        ? `${inventory.package} (${inventory.name})`
                        : `${inventory.ndc} (${inventory.name})`,
                    value: String(inventory.id)
                };
                selectedInventoryItems.push(item);
            });
            return selectedInventoryItems;
        };
        this.handleFilterInventories = (filterText) => {
            this.inventoryFilterText = filterText;
        };
        this.onChangeMultiSelect = (values) => {
            this.patient.sites = store_7.sitesListStore.sites.value
                ? store_7.sitesListStore.sites.value.filter(site => values.map(value => value.value).includes(String(site.id)) //
                )
                : [];
        };
        this.addPatientExclude = () => {
            var _a, _b, _c;
            const { invId, reasonId } = this.newExclude;
            const reason = (_a = this.cancellationReasons) === null || _a === void 0 ? void 0 : _a.find(cR => cR.id === Number(reasonId));
            const inventory = (_c = (_b = store_2.inventoryListStore === null || store_2.inventoryListStore === void 0 ? void 0 : store_2.inventoryListStore.inventories) === null || _b === void 0 ? void 0 : _b.value) === null || _c === void 0 ? void 0 : _c.find(inv => inv.id === Number(invId));
            const entry = {
                inventory,
                inventoryId: inventory.id,
                patientId: this.patient.id,
                reason,
                reasonId: reason.id,
                expiration: moment()
                    .add(reason.timeout, "days")
                    .format("YYYY-MM-DD")
            };
            this.patient.inventories = [...this.patient.inventories, entry];
            this.newExclude = {
                invId: "",
                reasonId: ""
            };
        };
        this.handleOnSubmitMerge = async (updatedPatientData, selectedPatients, allInsurances) => {
            this.showMergeModal = false;
            const patientMergeMeta = {
                allInsurances,
                currentPatient: this.patient,
                selectedPatients,
                updatedPatientData
            };
            await store_6.patientsStore.mergePatientsRelations(patientMergeMeta);
        };
        this.handleSubmit = async () => {
            // if (this.patient.notes === null) {
            //   this.patient.notes = "";
            // }
            console.log("click");
            if (!this.isValid(this.patient)) {
                this.setMissingFields();
            }
            else {
                this.missing = {
                    address: false,
                    birthDate: false,
                    firstName: false,
                    gender: false,
                    lastName: false,
                    site: false,
                    zip: false
                };
                console.log("this.props", this.props);
                if (this.props && this.insurance) {
                    await callable_1.callable(this.props.onSave)(this.patient, this.insurance);
                }
                else {
                    await callable_1.callable(this.props.onSave)(this.patient);
                }
                this.editInsurance = false;
                this.insurance = null;
                if (this.params.has("queue")) {
                    const queueRowId = Number(this.params.get("row"));
                    const data = { patient: this.patient };
                    if (!!this.samePatients) {
                        for (const row of this.samePatients) {
                            await store_5.ordersStore.updateQueue(row.id, data);
                        }
                    }
                    else {
                        await store_5.ordersStore.updateQueue(queueRowId, data);
                    }
                }
            }
            this.showConfirmationEditPatientSave = false;
        };
        this.handleCancel = () => {
            if (this.params.has("queue"))
                router_1.RouteManager.transitionTo("/claims/queue");
            else
                this.props.onCancel();
        };
        this.handleDelete = () => {
            callable_1.callable(this.props.onDelete)(this.patient);
        };
        this.handleUndelete = () => {
            callable_1.callable(this.props.onUndelete)(this.patient);
        };
        // Photo Uploads
        this.handleClickCancelUpload = () => {
            this.uploadModal = false;
        };
        this.viewPatientAssets = () => {
            this.assetModal = !this.assetModal;
        };
        this.onCredentialUpload = () => {
            this.uploadType = "credential";
            this.uploadModal = true;
        };
        this.onImageUpload = () => {
            this.uploadType = "image";
            this.uploadModal = true;
        };
        this.onDeleteAsset = async (uploadId) => {
            await store_6.patientsStore.deleteAsset(uploadId, this.patient.id);
        };
        this.handleE1Request = async () => {
            if (this.isCardFinderLoading) {
                return;
            }
            if (!this.isValid(this.patient)) {
                this.setMissingFields();
                return;
            }
            this.e1RequestInProgress = true;
            try {
                const wasUnsaved = !this.hasSavedPatientId(this.patient);
                if (wasUnsaved) {
                    const created = await store_6.patientsStore.createPatient(this.patient);
                    if (!created) {
                        this.showInsuranceFail = true;
                        return;
                    }
                    this.patient = ramda_1.merge(this.patient, created);
                }
                const logData = {
                    action: this.formatE1AuditAction("Initiated E1 request."),
                    category: store_3.LogCategory.patient,
                    categoryReferenceKey: this.patient.id,
                    site: this.patient.sites[0].id,
                    user: store_3.usersStore.user.value.id
                };
                await store_3.usersStore.createLog(logData);
                logData.action = "";
                const result = await store_6.patientsStore.insuranceRequest(this.patient);
                if (!result) {
                    this.showInsuranceFail = true;
                    logData.action = this.formatE1AuditAction("E1 failed to locate insurance.");
                }
                else {
                    this.patient = ramda_1.merge(this.patient, result);
                    logData.action = this.formatE1AuditAction("E1 successful, populated insurance.");
                }
                await store_3.usersStore.createLog(logData);
                if (this.props.slim && this.props.onAfterE1) {
                    await this.props.onAfterE1(this.patient);
                }
            }
            finally {
                this.e1RequestInProgress = false;
            }
        };
        this.openInsuranceEditModal = (insurance) => {
            if (!!insurance)
                this.insurance = insurance;
            this.editInsurance = true;
        };
    }
    get availableOptions() {
        const siteIds = this.patient.sites
            ? this.patient.sites.map(site => site.id)
            : [];
        const siteOptions = store_7.sitesListStore.sites.value
            ? store_7.sitesListStore.sites.value.filter(site => !siteIds.includes(site.id))
            : [];
        return siteOptions.map(site => ({
            id: site.id,
            label: site.displayName || site.name,
            tokenLabel: site.displayName || site.name,
            value: String(site.id)
        }));
    }
    get availableInventoryOptions() {
        var _a, _b, _c, _d, _e;
        const inventoryIds = (_c = (_b = (_a = this.patient) === null || _a === void 0 ? void 0 : _a.inventories) === null || _b === void 0 ? void 0 : _b.map((exclusion) => exclusion.inventoryId)) !== null && _c !== void 0 ? _c : [];
        const inventories = (_e = (_d = store_2.inventoryListStore === null || store_2.inventoryListStore === void 0 ? void 0 : store_2.inventoryListStore.inventories) === null || _d === void 0 ? void 0 : _d.value) !== null && _e !== void 0 ? _e : [];
        const inventoryOptions = inventories.filter((inventory) => inventoryIds.indexOf(inventory.id) < 0);
        let textFilteredInventoryOptions = inventoryOptions;
        if (this.inventoryFilterText) {
            const re = new RegExp("[ ]+", "g");
            const normalizeFilterText = this.inventoryFilterText
                .trim()
                .toLowerCase()
                .replace(re, "");
            textFilteredInventoryOptions = textFilteredInventoryOptions.filter((inventory) => {
                const normalizeInventoryName = inventory.name
                    .trim()
                    .toLowerCase()
                    .replace(re, "");
                return (inventory.package.includes(this.inventoryFilterText) ||
                    normalizeInventoryName.includes(normalizeFilterText));
            });
        }
        // return inventoryOptions.map((inventory: IInventory, i: number) => ({
        return textFilteredInventoryOptions
            .sort((a, b) => (a.package > b.package ? 1 : -1))
            .map((inventory) => ({
            id: inventory.id,
            label: inventory.package
                ? `${inventory.package} (${inventory.name})`
                : `${inventory.ndc} (${inventory.name})`,
            tokenLabel: inventory.package
                ? `${inventory.package} (${inventory.name})`
                : `${inventory.ndc} (${inventory.name})`,
            value: String(inventory.id)
        }));
    }
    // region React
    componentWillMount() {
        ReactTooltip.rebuild();
        this.checkIfNewPatient();
        this.patient = ramda_1.merge(dummyPatient, this.props.patient);
        if (this.patient.sites && this.patient.sites.length) {
            this.siteSelectedId = String(this.patient.sites[0].id);
        }
        const options = {
            group: "site.id"
        };
        store_7.sitesListStore.loadSitesNoRelation(options);
        this.missing = {
            address: false,
            birthDate: false,
            firstName: false,
            gender: false,
            lastName: false,
            site: false,
            zip: false
        };
        store_2.inventoryListStore.loadAllInventories();
        this.params = new URLSearchParams(document.location.search);
        if (this.isNewPatient && this.params.has("queue")) {
            this.populateFromQueue();
        }
        if (this.params.has("showcf"))
            this.hideCardFinder = true;
        if (!this.props.defaultSite)
            return;
        this.patient = ramda_1.merge(this.patient, { sites: [this.props.defaultSite] });
        this.error = "";
    }
    componentWillReceiveProps(props) {
        ReactTooltip.rebuild();
        if (props.patient) {
            this.patient = ramda_1.merge(dummyPatient, props.patient);
            this.checkIfNewPatient();
        }
        if (!props.defaultSite)
            return;
        this.patient = ramda_1.merge(this.patient, { sites: [props.defaultSite] });
        this.patient = ramda_1.merge(this.patient, {
            birthDate: moment(new Date(this.patient.birthDate)).format("YYYY-MM-DD")
        });
    }
    async componentDidMount() {
        const { data } = await store_4.appSettingsStore.readCancellations();
        this.cancellationReasons = data;
    }
    componentDidUpdate() {
        ReactTooltip.rebuild();
    }
    async populateFromQueue() {
        const result = await store_5.ordersStore.readQueueRow(this.params.get("row"));
        if (result) {
            const fullSiteQueue = await store_5.ordersStore.readQueue(result.siteId);
            const queuePatient = result.patientData.patient;
            this.patient = ramda_1.merge(this.patient, queuePatient);
            this.samePatients = fullSiteQueue.filter((row) => {
                const { patient } = row.patientData;
                if (patient.birthDate === this.patient.birthDate &&
                    patient.firstName === this.patient.firstName &&
                    patient.lastName === this.patient.lastName) {
                    return row;
                }
            });
        }
    }
    render() {
        var _a, _b, _c, _d, _e, _f, _g;
        const { slim = false } = this.props;
        const { patient } = this;
        const insurance = this.insurance || dummyInsurance;
        // C-094.1
        let DataVal;
        let isError = "";
        let errorStatus = false;
        const getNumber = patient.phone.slice(0, 14); // C-094.12 
        if (getNumber.length) {
            DataVal = getNumber.replace(/\D+/g, "")
                .replace(/(\d{3})(\d{3})(\d{4})/, "($1) $2-$3");
            if (DataVal) {
                if (DataVal.length != 14) {
                    isError = "The information input currently is invalid";
                    errorStatus = false;
                }
                else {
                    isError = "";
                    errorStatus = true;
                }
            }
        }
        const buttons = [];
        const insuranceArchive = () => {
            const list = this.viewArchive &&
                this.patient.insurances.length &&
                this.patient.insurances
                    .filter(ins => ins.deletedAt)
                    .map((ins, index) => this.renderArchive(ins, index));
            return list || null;
        };
        const shouldHideDelete = this.params.has("queue") || this.isNewPatient; // @tkay
        if (this.props.onDelete && !shouldHideDelete) {
            if (this.patient.deletedAt) {
                buttons.push(React.createElement(button_1.MaterialButton, { className: "btnDelete", onClick: this.handleUndelete }, "Undelete"));
            }
            else {
                buttons.push(React.createElement(button_1.MaterialButton, { className: "btnDelete", onClick: this.handleDelete }, "Delete"));
            }
        }
        buttons.push(React.createElement(button_1.MaterialButton, { className: "btnCancel", onClick: this.handleCancel }, "Cancel"), "save");
        const warning = this.props.warning
            ? "Patient is missing insurance information"
            : "";
        // This is to determine if there are any insurances that are deleted so that the "Toggle History" link will show. Since that link only shows insurances that are deleted.
        let showToggle = false;
        for (const insurance of this.patient.insurances) {
            if (insurance.deletedAt !== null) {
                showToggle = true;
                break;
            }
        }
        return (React.createElement("div", { className: "edit-patient" },
            React.createElement(ui_1.UiForm, { buttons: buttons, loading: this.props.loading, status: this.props.status, saved: "Saved", 
                // onSubmit={() => this.showConfirmationEditPatientSave = true}
                onSubmit: this.handleSubmit, isChanged: this.isChanged, error: this.error || this.props.error, warning: warning, shouldDisableSave: isError.length ? true : false },
                React.createElement("div", { className: "practice" },
                    React.createElement("div", { className: "main" },
                        React.createElement("h3", null, "PATIENT"),
                        React.createElement("div", { className: "patient-info" },
                            !slim && (React.createElement("div", { className: "row" },
                                React.createElement(multi_select_1.UiMultiSelect, { className: "sites", label: "Pharmacy *", missing: this.missing.site, singleSelect: true, options: this.availableOptions, values: this.getMultiSelectValues(), 
                                    // onChange={values => this.onChangeMultiSelect(values)}
                                    onChange: this.onChangeMultiSelect, onSearch: this.loadSites }))),
                            React.createElement("div", { className: "row" },
                                React.createElement(text_field_1.MaterialTextField, { autoFocus: true, label: "Prefix", onChange: this.handleChangeString("prefix"), value: patient.prefix }),
                                React.createElement(text_field_1.MaterialTextField, { autoFocus: true, label: "First Name *" // C-056
                                    , missing: this.missing.firstName, onChange: this.handleChangeString("firstName"), value: `${patient.firstName}` || "" }),
                                React.createElement(text_field_1.MaterialTextField, { label: "Middle Name" // C-056
                                    , onChange: this.handleChangeString("middleName"), value: `${patient.middleName}` || "" })),
                            React.createElement("div", { className: "row" },
                                React.createElement(text_field_1.MaterialTextField, { label: "Last Name *" // C-056
                                    , missing: this.missing.lastName, onChange: this.handleChangeString("lastName"), value: `${patient.lastName}` || "" }),
                                React.createElement(text_field_1.MaterialTextField, { label: "Suffix", onChange: this.handleChangeString("suffix"), value: patient.suffix })),
                            React.createElement("div", { className: "row" },
                                React.createElement(date_picker_1.MaterialDatePicker, { label: "Birthdate *", missing: this.missing.birthDate, disableFuture: true, onChange: this.handleChangeBirthdate, value: this.patient.birthDate
                                        ? this.patient.birthDate.toString()
                                        : "" }),
                                React.createElement(select_1.MaterialSelect, { label: "Gender *", missing: this.missing.gender, options: genderOptions, required: true, onSelect: this.handleSelect("gender"), value: patient.gender || "" }))),
                        React.createElement("div", { className: "patient-avatar" },
                            React.createElement("div", { style: { display: "flex", justifyContent: "center" } },
                                React.createElement(button_1.MaterialButton, { flat: true, secondary: true, onClick: () => {
                                        this.showMergeModal = true;
                                    } }, "Merge Patient")),
                            React.createElement(patient_image_1.PatientImage, { patientData: patient, upload: (patient === null || patient === void 0 ? void 0 : patient.uploads) || [], viewPatientAssets: this.viewPatientAssets }))),
                    React.createElement("div", { className: "main" },
                        React.createElement("h3", null, "CONTACT"),
                        React.createElement("div", { className: "contact-info" },
                            React.createElement("div", { className: "row" },
                                React.createElement(text_field_1.MaterialTextField, { label: "Address 1 *", missing: this.missing.address, onChange: this.handleChangeString("address"), value: patient.address || "" }),
                                React.createElement(text_field_1.MaterialTextField, { label: "Address 2", onChange: this.handleChangeString("address2"), value: (_a = patient.address2) !== null && _a !== void 0 ? _a : "" })),
                            React.createElement("div", { className: "row" },
                                React.createElement(text_field_1.MaterialTextField, { className: "city", label: "City", 
                                    // missing={this.missing.city}
                                    onChange: this.handleChangeString("city"), value: patient.city || "" }),
                                React.createElement("div", { className: "row" },
                                    React.createElement(select_1.MaterialSelect, { label: "State", 
                                        // missing={this.missing.state}
                                        options: states, required: true, onSelect: this.handleSelect("state"), value: patient.state || "", searchable: true }),
                                    React.createElement(text_field_1.MaterialTextField, { className: "zip", label: "Zip Code", required: true, missing: this.missing.zip, onChange: this.handleChangeString("zip"), value: patient.zip || "" }))),
                            React.createElement("div", { className: "row" },
                                React.createElement(text_field_1.MaterialTextField, { label: "Phone", leftItem: React.createElement(icons_1.PhoneIcon, null), onChange: this.handleChangeString("phone"), value: DataVal || "", missing: isError, helperText: isError }),
                                React.createElement(text_field_1.MaterialTextField, { label: "Email", leftItem: React.createElement(icons_1.EmailIcon, null), onChange: this.handleChangeString("email"), value: patient.email || "" })))),
                    !insurance.insuranceId ? (React.createElement("div", null, this.showInsuranceFail && (React.createElement(alert_1.UiAlert, { title: "Warning", type: "error", message: "Existing ERX patient insurance was not found; manually insert insurance below." })))) : null,
                    React.createElement("div", { className: "main" },
                        React.createElement("h3", null, "INSURANCE & COPAY"),
                        React.createElement("div", { className: "type-info__column", style: { marginLeft: "2em" } },
                            React.createElement(React.Fragment, null,
                                React.createElement(button_1.MaterialButton, { onClick: this.newInsurance, disabled: this.isNewPatient, style: this.requestButtonStyle }, "New"),
                                !this.hideCardFinder && !patient.confirmNoInsurance && (React.createElement(button_1.MaterialButton, { className: this.isCardFinderLoading
                                        ? "card-finder-btn card-finder-btn--loading"
                                        : "card-finder-btn", onClick: this.handleE1Request, disabled: this.isCardFinderLoading, style: this.isCardFinderLoading
                                        ? this.cardFinderLoadingStyle
                                        : this.cardFinderIdleStyle }, this.isCardFinderLoading
                                    ? "Running Card Finder"
                                    : "Run Card Finder")),
                                React.createElement(checkbox_1.MaterialCheckbox, { label: "Exclude from Insurance Claims", className: "material-checkbox__confirm-no-insurance", value: "confirmNoInsurance", onAction: () => this.checkConfirm(), checked: patient.confirmNoInsurance })),
                            this.renderInsurance(),
                            (this.patient.insurances.length && showToggle && (React.createElement("div", { className: "insurance-info" },
                                React.createElement("span", { className: "archive-btn", onClick: () => (this.viewArchive = !this.viewArchive) }, "Toggle History"),
                                this.viewArchive && insuranceArchive()))) ||
                                " ")),
                    React.createElement("div", { className: "main" },
                        React.createElement("h3", null, "OMIT NDC"),
                        React.createElement("div", { className: "notes-info" },
                            React.createElement("div", { className: "row" },
                                React.createElement(select_1.MaterialSelect, { label: "Medication", options: this.availableInventoryOptions, onSelect: e => {
                                        this.newExclude.invId = e;
                                    }, value: (_b = this.newExclude.invId) !== null && _b !== void 0 ? _b : "" }),
                                React.createElement(select_1.MaterialSelect, { label: "Reason to Omit", options: (_c = this.cancellationReasons) === null || _c === void 0 ? void 0 : _c.map(cr => ({
                                        id: cr.id,
                                        label: cr.reason,
                                        value: cr.id
                                    })), onSelect: e => {
                                        this.newExclude.reasonId = e;
                                    }, value: (_d = this.newExclude.reasonId) !== null && _d !== void 0 ? _d : "" }),
                                React.createElement(button_1.MaterialButton, { onClick: () => this.addPatientExclude(), primary: true }, "Add")),
                            React.createElement("div", null,
                                React.createElement("table", { style: { margin: "0 auto", width: "80%" } },
                                    React.createElement("thead", null,
                                        React.createElement("tr", null,
                                            React.createElement("td", null,
                                                React.createElement("b", null, "Medication")),
                                            React.createElement("td", null,
                                                React.createElement("b", null, "Reason")),
                                            React.createElement("td", null,
                                                React.createElement("b", null, "Expiration")),
                                            React.createElement("td", null))),
                                    React.createElement("tbody", null, (_f = (_e = this.patient) === null || _e === void 0 ? void 0 : _e.inventories) === null || _f === void 0 ? void 0 : _f.map((pExcl) => {
                                        const { reason: { reason: rText, confirmOnDelete }, inventoryId, inventory: { name, package: pkg }, expiration } = pExcl;
                                        const component = (React.createElement("tr", null,
                                            React.createElement("td", null,
                                                pkg,
                                                " (",
                                                name,
                                                ")"),
                                            React.createElement("td", null, rText),
                                            React.createElement("td", null, expiration !== null && expiration !== void 0 ? expiration : "Never"),
                                            (!confirmOnDelete ||
                                                (confirmOnDelete &&
                                                    store_3.usersStore.user.value.admin)) && (React.createElement("td", null,
                                                React.createElement(DeleteForever_1.default, { onClick: () => {
                                                        confirmOnDelete
                                                            ? ((this.removeNDCConfirmationModal = true),
                                                                (this.ndcPendingRemoval = inventoryId))
                                                            : this.filterPatientInventory(inventoryId);
                                                    }, style: { cursor: "pointer" } })))));
                                        return component;
                                    })))))),
                    React.createElement("div", { className: "main" },
                        React.createElement("h3", null, "NOTES"),
                        React.createElement("div", { className: "notes-info" },
                            React.createElement("div", { className: "row" },
                                React.createElement(text_area_1.MaterialTextArea, { className: "textarea", value: (_g = patient.notes) !== null && _g !== void 0 ? _g : "", onChange: this.handleChangeNotes, placeholder: "Notes" })))))),
            this.removeNDCConfirmationModal && (React.createElement(confirmation_modal_1.ConfirmationModal, { confirmText: "Remove", cancelText: "Cancel", message: `This medication has a high-priority "do not run" flag attributed to it.
            Removing the NDC from this omission list will allow the medication to be processed on the next claim submission.
            Are you sure you want to remove the medication from this list?`, onCancel: () => {
                    this.removeNDCConfirmationModal = false;
                }, onConfirm: () => {
                    this.filterPatientInventory(this.ndcPendingRemoval);
                    this.removeNDCConfirmationModal = false;
                }, title: "Remove Excluded NDC" })),
            this.editInsurance && this.editInsuranceModal(),
            React.createElement(ReactTooltip, { effect: "solid", place: "left" }),
            this.newPatientRequest && (React.createElement(confirmation_modal_1.ConfirmationModal, { confirmText: "Confirm", cancelText: "Cancel", message: "You must create and save the patient before requesting E1 Insurance Information.", onCancel: () => {
                    this.newPatientRequest = false;
                }, onConfirm: () => (this.newPatientRequest = false), title: "Insurance Request" })),
            this.showConfirmationEditPatientSave && (React.createElement(confirmation_modal_1.ConfirmationModal, { confirmText: "Save", cancelText: "Cancel", message: `Please confirm save. <br />Do you want to save the changes to this patient?`, onCancel: () => {
                    this.showConfirmationEditPatientSave = false;
                }, onConfirm: this.handleSubmit, title: "Save confirmation" })),
            this.assetModal ? (React.createElement(modal_1.AssetModal, { title: `Assets For ${this.patient.firstName} ${this.patient.lastName}`, width: "unset", maxWidth: "55%", maxHeight: "70%", top: "100px", onCancel: () => {
                    this.assetModal = !this.assetModal;
                } },
                React.createElement(asset_list_1.AssetList, { uploads: this.patient.uploads, entityType: "patient", entityData: this.patient, onCredentialUpload: this.onCredentialUpload, onDeleteUpload: this.onDeleteAsset, onImageUpload: this.onImageUpload, onDescriptionSave: this.handleAssetsDescriptionsSave, onExpDateSave: this.handleAssetsExpDateSave, onConnectAssetSave: this.handleAssetsDescriptionsSave, onCancel: () => {
                        this.assetModal = !this.assetModal;
                    } }))) : null,
            this.uploadModal && (React.createElement(upload_modal_1.UploadModal, { onCancel: this.handleClickCancelUpload, message: `Please select files for ${this.patient.firstName} ${this.patient.lastName}.`, title: "Upload Asset", onDrop: this.handleAssetsUpload })),
            this.confirmDeleteInsuranceModal && (React.createElement(confirmation_modal_1.ConfirmationModal, { confirmText: "Delete Insurance", cancelText: "Cancel", message: `Please confirm. <br />Do you want to delete this insurance card from the patient?`, onCancel: () => {
                    this.confirmDeleteInsuranceModal = false;
                }, onConfirm: this.handleDeleteInsurance, title: "Insurance Request" })),
            this.showMergeModal && (React.createElement(patient_merge_modal_1.PatientMergeModal, { showModal: this.showMergeModal, onCancel: () => {
                    this.showMergeModal = false;
                }, patient: this.patient, onSubmitMerge: this.handleOnSubmitMerge }))));
    }
    get isCardFinderLoading() {
        return (this.e1RequestInProgress || Boolean(store_6.patientsStore.patient.loading));
    }
};
__decorate([
    mobx_1.computed
], EditPatient.prototype, "availableOptions", null);
__decorate([
    mobx_1.computed
], EditPatient.prototype, "availableInventoryOptions", null);
__decorate([
    mobx_1.observable
], EditPatient.prototype, "inventoryFilterText", void 0);
__decorate([
    mobx_1.observable
], EditPatient.prototype, "patient", void 0);
__decorate([
    mobx_1.observable
], EditPatient.prototype, "cancellationReasons", void 0);
__decorate([
    mobx_1.observable
], EditPatient.prototype, "newExclude", void 0);
__decorate([
    mobx_1.observable
], EditPatient.prototype, "insurance", void 0);
__decorate([
    mobx_1.observable
], EditPatient.prototype, "copay", void 0);
__decorate([
    mobx_1.observable
], EditPatient.prototype, "editInsurance", void 0);
__decorate([
    mobx_1.observable
], EditPatient.prototype, "error", void 0);
__decorate([
    mobx_1.observable
], EditPatient.prototype, "requestButtonStyle", void 0);
__decorate([
    mobx_1.observable
], EditPatient.prototype, "missing", void 0);
__decorate([
    mobx_1.observable
], EditPatient.prototype, "removeNDCConfirmationModal", void 0);
__decorate([
    mobx_1.observable
], EditPatient.prototype, "ndcPendingRemoval", void 0);
__decorate([
    mobx_1.observable
], EditPatient.prototype, "confirmDeleteInsuranceModal", void 0);
__decorate([
    mobx_1.observable
], EditPatient.prototype, "hideCardFinder", void 0);
__decorate([
    mobx_1.observable
], EditPatient.prototype, "isNewPatient", void 0);
__decorate([
    mobx_1.observable
], EditPatient.prototype, "newPatientRequest", void 0);
__decorate([
    mobx_1.observable
], EditPatient.prototype, "e1RequestInProgress", void 0);
__decorate([
    mobx_1.observable
], EditPatient.prototype, "originalInsurance", void 0);
__decorate([
    mobx_1.observable
], EditPatient.prototype, "params", void 0);
__decorate([
    mobx_1.observable
], EditPatient.prototype, "samePatients", void 0);
__decorate([
    mobx_1.observable
], EditPatient.prototype, "showConfirmationEditPatientSave", void 0);
__decorate([
    mobx_1.observable
], EditPatient.prototype, "viewArchive", void 0);
__decorate([
    mobx_1.observable
], EditPatient.prototype, "assetModal", void 0);
__decorate([
    mobx_1.observable
], EditPatient.prototype, "photoUploadModal", void 0);
__decorate([
    mobx_1.observable
], EditPatient.prototype, "showInsuranceFail", void 0);
__decorate([
    mobx_1.observable
], EditPatient.prototype, "showMergeModal", void 0);
__decorate([
    mobx_1.observable
], EditPatient.prototype, "siteSelectedId", void 0);
__decorate([
    mobx_1.observable
], EditPatient.prototype, "uploadModal", void 0);
__decorate([
    mobx_1.observable
], EditPatient.prototype, "uploadType", void 0);
__decorate([
    mobx_1.computed
], EditPatient.prototype, "isCardFinderLoading", null);
EditPatient = __decorate([
    mobx_react_1.observer
], EditPatient);
exports.EditPatient = EditPatient;



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/patients/modules/patients-detail/components/edit-patient/edit-patient.tsx
// module id = 3772
// module chunks = 0